import * as React from 'react';
import withEventTracker from './withEventTracker';

class TrackableInput extends React.Component {
  static defaultProps = {
    multiline: false,
    trackValue: true
  };

  startEventSent = false;

  handleChange = event => {
    const {
      eventCategory,
      startEventAction,
      editEventAction,
      eventTracker,
    } = this.props;

    if (!this.startEventSent && eventCategory) {
      const eventAction = this.props.value ? editEventAction : startEventAction;
      if (eventAction) {
        eventTracker.send(eventCategory, eventAction);
      }

      this.startEventSent = true;
    }

    const eventHandler = this.props.onChange;
    if (typeof eventHandler === 'function') {
      eventHandler(event);
    }
  };

  handleBlur = event => {
    const {
      eventCategory,
      finishEventAction,
      trackValue,
      eventTracker,
    } = this.props;

    if (this.startEventSent && eventCategory) {
      if (finishEventAction) {
        eventTracker.send(
          eventCategory,
          finishEventAction,
          trackValue ? event.target.value : '',
        );
      }

      this.startEventSent = false;
    }

    const eventHandler = this.props.onBlur;
    if (typeof eventHandler === 'function') {
      eventHandler(event);
    }
  };

  render() {
    const {
      eventCategory,
      startEventAction,
      editEventAction,
      finishEventAction,
      eventTracker,
      inputRef,
      multiline,
      trackValue,
      ...props
    } = this.props;

    const Element = multiline ? 'textarea' : 'input';

    return (
      <Element
        {...props}
        ref={inputRef}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        // Add HTML attributes for documentation purposes
        data-event-category={eventCategory}
        data-event-action={finishEventAction || startEventAction || editEventAction}
      />
    );
  }
}

export default withEventTracker(TrackableInput);
